import type { TicketDetailDto } from "@megaron/support-contracts";

export function getSupportTicketCreatedByEmail(ticket: TicketDetailDto): string | null {
  const createdEntry = ticket.history?.find((entry) => entry.entryType === "ticketCreated");
  return createdEntry?.changedByEmail ?? null;
}
